import {
	Resources,
	type useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { PORTFOLIO_CONTRACT_STATE } from "web_myplann/Portfolio/Components/Redesign/Filter/portfolioContractState";
import { isPortfolioSortActive } from "web_myplann/Portfolio/Helpers/isPortfolioSortActive";
import { portfolioGroupLabel } from "web_myplann/Portfolio/Helpers/portfolioCategoryMapping";
import type { PortfolioFilterState } from "web_myplann/Shared/State/portfolioFilterAtom";

type TranslateFn = ReturnType<typeof useResource>["t"];

export const portfolioFilterSummary = (
	filter: PortfolioFilterState,
	t: TranslateFn,
): string => {
	const { categories } = filter;

	const categoryPart =
		categories.length === 1
			? t(portfolioGroupLabel(categories[0]))
			: categories.length > 1
				? t(Resources.Portfolio.List.Redesign.selectedCategoriesCount, {
						count: categories.length,
					})
				: undefined;

	const contractStatePart =
		filter.contractState === PORTFOLIO_CONTRACT_STATE.archived
			? t(Resources.Portfolio.List.Redesign.archivedSummary)
			: undefined;

	const sortPart = isPortfolioSortActive(filter)
		? t(Resources.Portfolio.List.Redesign.Sort[filter.sort])
		: undefined;

	return [categoryPart, contractStatePart, sortPart]
		.filter((part) => part !== undefined)
		.join(", ");
};
